module.exports = __webpack_public_path__ + "p3_img2.jpg?13b686c2cceb700a569af4aed89f5161";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img2.jpg
// module id = 111
// module chunks = 0